import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';

export default class commentListComponent extends Component {
  @service('current-user') currentUser;
  @tracked _showFullList = false;
  @service store;

  get showFullList() {
    if (this.args.allCommentsOpen) {
      return this.args.allCommentsOpen;
    } else if (this.args.showComments && this.args.itemActive) {
      return this.args.showComments;
    } else {
      return this._showFullList;
    }
  }

  set showFullList(value) {
    this._showFullList = value;
  }

  get isInteractive() {
    return this.args.interactive !== false;
  }

  // Expanding is this component's own business. It used to delegate to the
  // parent, whose hook created a draft comment as a side effect of making the
  // item active — so merely reading the rest of a thread posted an empty
  // comment.
  @action
  openList() {
    if (this.showFullList) return;
    this._showFullList = true;
  }

  @action
  collapseList() {
    // Only unwind the expansion this component owns. The @allCommentsOpen and
    // @showComments paths belong to the parent and it closes those itself.
    if (!this._showFullList) return;
    this._showFullList = false;
    this.args.closeList?.();
  }
}
